import { Outlet } from "react-router-dom";

/**
 * Empty `/admin` shell (s-admin-authz-shell-advice-019e9cbb, slice 1). Renders
 * NO firm data — sibling slices (list / exceptions / read-only viewer) mount
 * their surfaces under this shell via the nested <Outlet />.
 */
export default function AdminShell() {
  return (
    <section aria-label="Admin">
      <h1>Admin</h1>
      <Outlet />
    </section>
  );
}
